<template>
  <!-- DESKTOP -->
  <div v-if="layoutSize === 'lg' || layoutSize === 'xl'">
    <div class="actionHeader">
      <div class="search">
        <div class="search__input-container">
          <input
            type="text"
            class="search__input form-textField"
            :placeholder="$t('search.inputPlaceholder')"
            :value="searchPhrase"
            @keyup="updateSearch"
          />
          <button v-if="searchPhrase != ''" @click="resetSearch" class="search__input__reset"></button>
        </div>
        <!-- .search__input-container -->
        <select class="search__select form-select" @change="updateSearchArea($event)">
          <option value="all" :selected="!searchInSelection">
            {{ $t('search.searchInAll') }}
          </option>
          <option value="filtered" :selected="searchInSelection">
            {{ $t('search.searchInSelection') }}
          </option>
        </select>
        <button type="submit" class="search__button button button--primary"></button>
      </div>
      <!-- .search -->

      <div class="actions">
        <div class="actions__viewMode">
          <button
            class="actions__viewMode__button -list button"
            :class="{
              '-active button--primary': viewMode === 'list',
              'button--secondary': viewMode !== 'list',
            }"
            @click="setViewMode('list')"
          ></button>
          <button
            class="actions__viewMode__button -grid button"
            :class="{
              '-active button--primary': viewMode === 'grid',
              'button--secondary': viewMode !== 'grid',
            }"
            @click="setViewMode('grid')"
          ></button>
        </div>
        <!-- .actions__viewMode -->

        <select class="actions__sortSelect form-select" v-model="sort">
          <option value="relevance">{{ $t('sort.relevance') }}</option>
          <option value="alphabetically">{{ $t('sort.alphabetically') }}</option>
          <option value="price_asc">{{ $t('sort.priceAsc') }}</option>
          <option value="price_desc">{{ $t('sort.priceDesc') }}</option>
          <option value="date_added_desc">{{ $t('sort.dateAddedDesc') }}</option>
          <option value="mileage_asc">{{ $t('sort.mileageAsc') }}</option>
        </select>

        <router-link v-if="showCompare" :to="'/vergelijken'" class="actions__compareButton button button--secondary button--compare">
          {{ $t('filters.compare') }}
          <span v-if="countCompareVehicles > 0" class="actions__compareButton__countBadge">{{ countCompareVehicles }}</span>
        </router-link>
      </div>
      <!-- .actions -->
    </div>
    <!-- actionHeader -->
  </div>

  <!-- MOBILE -->
  <div v-else>
    <h1 class="actions__title">{{ $t('filters.title') }}</h1>
    <div class="actionHeader">
      <div class="actions actions--mobile">
        <router-link v-if="showCompare" :to="'/vergelijken'" class="actions__compareButton button button--secondary button--compare">{{
          $t('filters.compare')
        }}</router-link>
        <button v-on:click="showFilterModal" class="actions__filterButton button button--secondary button--filter">
          {{ $t('filters.filter') }}
        </button>
        <button v-on:click="showSearchModal" class="actions__searchButton button button--primary button--search"></button>

        <div class="actions__selectContainer">
          <select class="actions__selectBrand primaryFilters__select--brand form-select" @change="updateBrand($event)">
            <option value="">{{ $t('filters.allBrands') }}</option>
            <option v-for="brand in brands" :key="brand.id" :selected="brand.id === selectedBrand" :value="brand.id">
              {{ brand.label }}
            </option>
          </select>
          <select :disabled="selectedBrand === ''" class="actions__selectModel form-select" @change="updateModel($event)">
            <option value="">{{ $t('filters.allModels') }}</option>
            <option v-for="model in models" :key="model.id" :selected="model.id === selectedModel" :value="model.id">
              {{ model.label }}
            </option>
          </select>
        </div>
        <!-- .actions__selectContainer -->
        <select class="actions__sortSelect form-select" v-model="sort">
          <option value="relevance">{{ $t('sort.relevance') }}</option>
          <option value="alphabetically">{{ $t('sort.alphabetically') }}</option>
          <option value="price_asc">{{ $t('sort.priceAsc') }}</option>
          <option value="price_desc">{{ $t('sort.priceDesc') }}</option>
          <option value="date_added_desc">{{ $t('sort.dateAddedDesc') }}</option>
          <option value="mileage_asc">{{ $t('sort.mileageAsc') }}</option>
        </select>
      </div>
      <!-- .actions -->
    </div>
    <!-- .actionHeader -->

    <div ref="searchModalWrapper">
      <div class="imot" :class="textColorClass" v-if="searchModalActive" ref="searchModal">
        <div class="searchModal" v-body-scroll-lock="true">
          <div class="searchModal__header">
            <h1 class="searchModal__title">{{ $t('filters.title') }}</h1>
            <button v-on:click="hideSearchModal" class="searchModal__closeButton button button--close"></button>
          </div>
          <!-- .searchModal__header -->

          <span class="searchModal__label">{{ $t('search.inputTitle') }}</span>
          <div class="searchModal__field-container">
            <input
              type="text"
              class="searchModal__field form-textField"
              :placeholder="$t('search.inputPlaceholder')"
              :value="searchPhrase"
              @keyup="updateSearch"
            />
            <button v-if="searchPhrase != ''" @click="resetSearch" class="searchModal__field__reset"></button>
          </div>

          <span class="searchModal__label">{{ $t('search.searchIn') }}</span>
          <select class="searchModal__field form-select" @change="updateSearchArea($event)">
            <option value="all" :selected="!searchInSelection">
              {{ $t('search.searchInAll') }}
            </option>
            <option value="filtered" :selected="searchInSelection">
              {{ $t('search.searchInSelection') }}
            </option>
          </select>
          <button
            v-on:click="hideSearchModal"
            class="searchModal__button button button--primary button--searchWithText button--full"
            type="submit"
          >
            {{ $t('search.submit') }}
          </button>
        </div>
        <!-- .searchModal -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  components: {},
  data() {
    return {
      sort: this.$store.state.vehicles.sort,
    }
  },
  computed: {
    searchModalActive: function () {
      return this.$store.state.search.searchModalActive
    },
    searchPhrase: function () {
      return this.$store.state.search.searchPhrase
    },
    searchInSelection: function () {
      return this.$store.state.search.searchInSelection
    },
    brands: function () {
      return this.$store.getters['filters/brands']
    },
    models: function () {
      return this.$store.getters['filters/models']
    },
    selectedBrand: function () {
      return this.$store.state.filters.selectedBrand
    },
    viewMode: function () {
      return this.$store.state.vehicles.viewMode
    },
    countCompareVehicles: function () {
      return this.$store.getters['compare/vehicles'].length
    },
    layoutSize: function () {
      return this.$store.state.layout.size
    },
    textColorClass: function () {
      return this.$store.state.settings.general !== null ? '-mainTextColor-' + this.$store.state.settings.general.mainTextColor : ''
    },
    showCompare: function () {
      return this.$store.state.settings.general.showCompare
    },
  },
  watch: {
    sort: function (val) {
      this.$store.commit('vehicles/updateSorting', val)
    },
    searchModalActive(isModalActive) {
      if (isModalActive === true) {
        this.$nextTick(function () {
          const modalEl = this.$refs.searchModal
          modalEl.parentNode.removeChild(modalEl)
          document.body.appendChild(modalEl)
        })
      } else {
        const modalEl = this.$refs.searchModal
        modalEl.parentNode.removeChild(modalEl)
        this.$refs.searchModalWrapper.appendChild(modalEl)
      }
    },
    layoutSize(newValue) {
      if (newValue === 'lg' || newValue === 'xl') {
        this.hideSearchModal()
      }
    },
  },
  methods: {
    updateSearch(e) {
      const value = e.target.value
      if (e.key === 'Enter') {
        // Direct search (after user submits field)
        this.$store.commit('search/update', value)
        this.sort = 'relevance'
      } else {
        // Delay search with 500ms after stop typing
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.$store.commit('search/update', value)
          this.sort = 'relevance'
        }, 500)
      }
    },
    updateBrand(event) {
      const brand = event.target.value
      this.$store.commit('filters/updateBrand', brand)
      this.$store.commit('search/searchInSelection', true)
    },
    updateModel(event) {
      const model = event.target.value
      this.$store.commit('filters/updateModel', model)
      this.$store.commit('search/searchInSelection', true)
    },
    resetSearch(e) {
      this.$store.commit('search/update', '')
    },

    updateSearchArea(e) {
      // Check if search area is set to 'all' or only 'filtered' selection
      const searchInSelection = e.target.value === 'filtered'
      this.$store.commit('search/searchInSelection', searchInSelection)
    },

    setViewMode(newMode) {
      if (this.viewMode !== newMode) {
        this.$store.commit('vehicles/toggleViewMode')
      }
    },
    showFilterModal() {
      this.$store.commit('filters/updateFilterModal', true)
    },
    showSearchModal() {
      this.$store.commit('search/updateSearchModal', true)
    },
    hideSearchModal() {
      this.$store.commit('search/updateSearchModal', false)
    },
  },
}
</script>
